// 全屏-档案馆
<template>
  <div class="DkbFNARA">
    <div class="topArea" v-if="StockInfo.Total!==undefined">
      <ul class="sideArea">
        <li class="li sumLi">
          <p class="text">当前档案库存数量</p>
          <p class="sum">{{StockInfo.Total}}</p>
        </li>
        <li class="li">
          <p class="item">
            <span class="text">今日借出档案数</span>
            <span class="num">{{StockInfo.Loan.Num}}</span>
          </p>
          <p class="item" v-show="!$route.meta.LSS"><!--绿瘦不显示百分比-->
            <span class="text">占总数</span>
            <span class="PCT">{{StockInfo.Loan.Ratio}}%</span> 
          </p>
        </li>
        <li class="li">
          <p class="item">
            <span class="text">今日归还档案数</span>
            <span class="num">{{StockInfo.Returned.Num}}</span>
          </p>
          <p class="item" v-show="!$route.meta.LSS">
            <span class="text">占总数</span>
            <span class="PCT">{{StockInfo.Returned.Ratio}}%</span>
          </p>
        </li>
        <li class="li">
          <p class="item">
            <span class="text">待归还档案数</span>
            <span class="num">{{StockInfo.SReturn.Num}}</span>
          </p>
          <p class="item" v-show="!$route.meta.LSS">
            <span class="text">占总数</span>
            <span class="PCT">{{StockInfo.SReturn.Ratio}}%</span>
          </p>
        </li>
      </ul>
      <div class="d3">
        <!-- <img class="img" :src="ModelImg" alt="3d"> -->
        <img class="img" src="/static/images/dkb/NARA/3d.gif" alt="3d">
      </div> 
    </div>
    <!-- 轮播区 -->
    <div class="swiperArea">
      <swiper :class="['swiper', 'hasItem'+swiperOption.slidesPerView]" :options="swiperOption" ref="mySwiper">
        <!-- 借/还档案记录 -->
        <swiper-slide class="swiperItem record" v-if="Result.RecordList">
          <p class="recordTit">借/还档案记录</p>
          <div class="li listTit">
            <p class="No">编号</p>
            <p class="name">姓名</p>
            <p class="des">借阅/归还档案</p>
            <p class="time">时间</p>
          </div>
          <div class="recordList DkbScroll">
            <div class="li" v-for="(item, index) in RecordList" :key="index">
              <p class="No">{{index+1}}</p>
              <p class="name">{{item.Name}}</p>
              <p class="des">{{item.Des}}</p>
              <p class="time">{{item.Time}}</p>
            </div>
          </div>
        </swiper-slide>
        <!-- 设备温湿度 -->
        <swiper-slide class="swiperItem deviceTH" v-if="Result.DeviceTHInfo">
          <DeviceTHInfo :sInfo="DeviceTHInfo" />
        </swiper-slide>
        <!-- 温湿度 -->
        <swiper-slide class="swiperItem T" v-if="Result.THInfo">
          <div class="GaugeArea">
            <div class="Gauge">
              <div class="chart" id="nowT"></div>
              <p class="text">当前温度</p>
            </div>
            <div class="Gauge">
              <div class="chart" id="nowH"></div>
              <p class="text">当前湿度</p>
            </div>
            <div class="Gauge" v-if="Result.HasVrvT">
              <div class="chart" id="nowVrvT"></div>
              <p class="text">当前空调温度</p>
            </div>
          </div>
          <div class="selectArea">
            <span
              :class="['text', {'active': item.value === nowTimeType }]"
              v-for="(item, index) in timeTypeList" :key="index"
              @click="selectTimeType(item.value)">{{item.label}}</span>
          </div>
          <div class="mixChart" id="THMix"></div>
        </swiper-slide>
        <!-- 视频 -->
        <swiper-slide class="swiperItem video" v-if="Result.VideoList && !$route.meta.LSS">
          <div class="videoBox" @click="videoOperate">
            <video id="nowVideo" :src="VideoList[nowVideoIndex]">
            your browser does not support the video tag
            </video>
            <img class="icon" src="/static/images/dkb/NARA/icon_play.png" alt="" v-if="!videoStatus">
          </div>
          <DkbPaging
            mini
            :page-index="nowVideoIndex+1" 
            :total="VideoList.length" 
            :page-size=1 
            @change="videoPageChange"
            v-if="VideoList.length>1">
          </DkbPaging>
          <span class="fsBtn" @click="settingFS"></span>
        </swiper-slide>
        <!-- 水电表 -->
        <swiper-slide class="swiperItem WE" v-if="Result.WEInfo && !$route.meta.LSS">
          <WEInfo :sWEInfo="WEInfo" />
        </swiper-slide>
        <!-- 消毒机操作记录 -->
        <swiper-slide class="swiperItem record" v-if="Result.SterilizerRecordList && !$route.meta.LSS">
          <p class="recordTit">净化消毒机操作记录</p>
          <div class="li listTit">
            <p class="No">编号</p>
            <p class="name">姓名</p>
            <p class="des">操作类型</p>
            <p class="time">时间</p>
          </div>
          <div class="recordList DkbScroll">
            <div class="li" v-for="(item, index) in SterilizerRecordList" :key="index">
              <p class="No">{{index+1}}</p>
              <p class="name">{{item.Name}}</p>
              <p class="des">{{item.Des}}</p>
              <p class="time">{{item.Time}}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
          <div :class="['swiper-button swiper-button-prev swiper-button-prev1', {'opacity': swiperNum<=2}]" slot="button-prev"></div>
          <div :class="['swiper-button swiper-button-next swiper-button-next1', {'opacity': swiperNum<=2}]" slot="button-next"></div>
    </div>

  </div>
</template>

<script>
  import WEInfo from '@/components/DkbPage/FScreen/NARA/SwiperSlide/WEInfo'
  import DeviceTHInfo from '@/components/DkbPage/FScreen/NARA/SwiperSlide/DeviceTHInfo'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import DkbPaging from '@/components/DkbPage/Layout/DkbPaging'  // 分页组件
  import { showToast } from "../../../../../static/js/utility/utility.js"
  import { dkbApi } from "../../../../../static/js/dkb/dkb.js"
  let echarts = require('echarts')
  // 借还记录循环，库存记录循环，温湿度循环
  let vm, jhTimer, kcTimer, wsTimer

  export default {
    name: 'DkbFNARA',
    components: {
      swiper,
      swiperSlide,
      DkbPaging,
      WEInfo,
      DeviceTHInfo
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    data () {
      return {
        // 轮播图
        swiperOption: {
          // slidesPerView: 3,
          // spaceBetween: (23/100)*this.$store.state.htmlFontSize,
          autoplay: {
            delay: 1000*30,
            disableOnInteraction: false,
          },
          slidesPerView: 2,
          spaceBetween: (15/100)*this.$store.state.htmlFontSize,
          navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
          },
        },
        swiperNum: 0,

        Result: {},
        /* 库存信息 */
        StockInfo: {},

        /* 借出/归还记录列表 */
        RecordList: [],

        /* 温湿度 */
        THInfo: {}, // 温湿度信息
        timeTypeList: [ // 时间类型，1天，2周，月3
          {
            value: 1,
            label: '天'
          },
          {
            value: 2,
            label: '周'
          },
          {
            value: 3,
            label: '月'
          },
        ],
        nowTimeType: 1, // 当前显示

        // 设备温湿度
        DeviceTHInfo: {},

        /* 视频 */
        VideoList: [],
        nowVideoIndex: 0,
        videoStatus: false,  // 视频状态

        /* 水电表 */
        WEInfo: {},

        /* 消毒机操作记录 */
        SterilizerRecordList: [],
        
      }
    },
    created () {
      vm = this
      vm.getFSNARAInfo()
      vm.timeRefresh()
    },
    mounted() {
      // console.log('route', this.$route)
    },
    destroyed () {
      clearInterval(jhTimer)
      clearInterval(kcTimer)
      clearInterval(wsTimer)
    },
    methods: {
      // 获取全屏档案馆的信息
      async getFSNARAInfo () {
        let res = await dkbApi.getFSNARAInfo()
        if (res.ErrCode === 0 ) {
          let Result = res.Result
          vm.swiperNum = Object.keys(Result).length-2
          for (let i in Result) {
            // console.log('i', i)
            vm[i] = Result[i]
          }
          vm.Result = Result
          // console.log('vm.Result', vm.Result)
          // 绘制图表
          vm.$nextTick(()=>{
            vm.drawHTChart()
          })
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 定时刷新数据
      timeRefresh () {
        jhTimer = setInterval(()=>{
          vm.getFSNARARecordList()
        }, 1000*3)
        kcTimer = setInterval(()=>{
          vm.getFSNARAStockInfo()
        }, 1000*3)
        wsTimer = setInterval(()=>{
          vm.getNARATHInfo()
        }, 1000*3)
      },
      // 获取全屏档案馆的库存信息
      async getFSNARAStockInfo () {
        let res = await dkbApi.getFSNARAStockInfo()
        if (res.ErrCode === 0) {
          vm.StockInfo = res.Result
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 获取全屏档案馆的借还记录
      async getFSNARARecordList () {
        let res = await dkbApi.getFSNARARecordList()
        if (res.ErrCode === 0) {
          vm.RecordList = res.Result
        } else {
          showToast(res.meta.ErrMsg)
        }
      },
      // 获取档案馆温湿度详情
      async getNARATHInfo () {
        let data = { nowTimeType: vm.nowTimeType }
        let res = await dkbApi.getNARATHInfo(data)
        // console.log('res', res)
        if (res.ErrCode === 0) {
          vm.THInfo = res.Result
          // 绘制图表
          vm.drawHTChart()
        } else {
          showToast(res.ErrMsg)
        }
      },
      // 选择时间类型
      selectTimeType (val) {
        vm.nowTimeType = val
        clearInterval(wsTimer)
        vm.getNARATHInfo()
        wsTimer = setInterval(()=>{
          vm.getNARATHInfo()
        }, 1000*3)
      },
      // 绘制温湿度图表
      drawHTChart () {
        vm.getTChart('nowT', 'NowT')
        vm.getHChart('nowH', 'NowH')
        if (vm.Result.HasVrvT) { vm.getTChart('nowVrvT', 'NowVrvT') }
        vm.getMixChart('THMix', 'THMix')
      },
      // 获取湿度仪表
      getHChart (id, vid) {
        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let dataVlaue = vm.THInfo[vid]

        let option = {
          grid: {
            left: '0',
            right: '0',
            top: 0,
            bottom: '0',
            containLabel: true
          },
          tooltip : {
            formatter: "{a} : {c}℃"
          },
          series: [
            {
              name: '仪表盘',
              type: 'gauge',
              radius: '100%',
              min: 0,
              max: 100,
              splitNumber: 5,
              // 轴线
              axisLine: {
                lineStyle: {
                  width: (10/100)*htmlFontSize,
                  color: [[0.2, '#6cc4bd'], [0.8, '#51c1e1'], [1, '#ea5413']]
                }
              },
              // 刻度标签
              axisLabel: {
                distance: (2/100)*htmlFontSize,
                fontSize: (8/100)*htmlFontSize,
                formatter: '{value}'
              },
              // 分割线
              splitLine: {
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  opacity: 0
                }
              },
              // 刻度
              axisTick: {
                splitNumber: 1,
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  color: '#093053'
                }
              },
              // 指针
              pointer: {
                show: true,
                length: (25/100)*htmlFontSize,
                width: (2/100)*htmlFontSize, //指针粗细
              },
              detail: {
                formatter: '{value}%',
                color: '#51c1e1',
                fontSize: (12/100)*htmlFontSize,
                offsetCenter: [0, '62.5%']
              },
              data: [{value: dataVlaue}]
            },
          ]
        }
        myChart.setOption(option, true)
        // setInterval(function () {
        //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0
          
        // },2000)
      },
      // 获取温度仪表
      getTChart (id, vid) {
        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let dataVlaue = vm.THInfo[vid]

        let option = {
          grid: {
            left: '0',
            right: '0',
            top: 0,
            bottom: '0',
            containLabel: true
          },
          tooltip : {
            formatter: "{a} : {c}℃"
          },
          series: [
            {
              name: '仪表盘',
              type: 'gauge',
              radius: '100%',
              min: -50,
              max: 50,
              splitNumber: 5,
              // 轴线
              axisLine: {
                lineStyle: {
                  width: (10/100)*htmlFontSize,
                  color: [[0.2, '#6cc4bd'], [0.8, '#51c1e1'], [1, '#ea5413']]
                }
              },
              // 刻度标签
              axisLabel: {
                distance: (2/100)*htmlFontSize,
                fontSize: (8/100)*htmlFontSize,
                // padding: [0, (10/100)*htmlFontSize, 0, 0],
                formatter: function (value) {
                  return value
                  // return Math.abs(value)
                }
              },
              // 分割线
              splitLine: {
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  opacity: 0
                }
              },
              // 刻度
              axisTick: {
                splitNumber: 1,
                length: (10/100)*htmlFontSize,
                lineStyle: {
                  color: '#093053'
                }
              },
              // 指针
              pointer: {
                show: true,
                length: (25/100)*htmlFontSize,
                width: (2/100)*htmlFontSize, //指针粗细
              },
              detail: {
                formatter: function (value) {
                  return value + '℃'
                },
                color: '#51c1e1',
                fontSize: (12/100)*htmlFontSize,
                offsetCenter: [0, '62.5%']
              },
              data: [{value: dataVlaue}]
            },
          ]
        }
        myChart.setOption(option, true)
        // setInterval(function () {
        //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0
          
        // },2000)
      },
      // 获取温湿度混合图表数据
      getMixChartData () {
        let list = [...vm.THInfo.List]
        let nowTimeType = vm.nowTimeType
        let xInterval = nowTimeType === 1 ? 6 : nowTimeType === 2 ? 0 : 8
        let xData = [], TValArr = [], TMinB = 0, TMaxB = 5, HValArr = [], HMaxB = 5
        list.forEach(function (item, index) {
          xData.push(item.Label)
          let TB = Math.ceil(item.TValue/10)
          let TBm = Math.floor(item.TValue/10)
          if (TB > TMaxB) { TMaxB = TB}
          if (TBm < TMinB) {TMinB = TBm}
          TValArr.push(item.TValue)
          let HB = Math.ceil(item.HValue/10)
          if (HB > HMaxB) { HMaxB = HB}
          HValArr.push(item.HValue)
        })
        let TMinVal = TMinB*10
        let TMaxVal = TMaxB*10
        let HMaxVal = HMaxB*10
        return { xData, xInterval, TValArr, TMinVal, TMaxVal, HValArr, HMaxVal }
      },
      // 获取温湿度混合图表
      getMixChart (id) {
        // 获取数据
        let { xData, xInterval, TValArr, TMinVal, TMaxVal, HValArr, HMaxVal } = vm.getMixChartData()

        let myChart = echarts.init(document.getElementById(id))
        let htmlFontSize = vm.$store.state.htmlFontSize
        let getSeriesItemStyle = function(isH){
          let seriesItemStyle = {
                normal: {
                  opacity:0,
                  color: 'transparent',
                  borderWidth: 0,
                },
                emphasis: {
                  opacity: 1,
                  color: '#ffffff',
                  shadowColor: 'rgba(81, 193, 225, 0.58)',
                  shadowBlur: 3,
                  label: {
                    show: true,
                    position: [(10/100)*htmlFontSize, -(15/100)*htmlFontSize],
                    color: '#fff',
                    fontSize: (12/100)*htmlFontSize,
                    padding: [0, (5/100)*htmlFontSize],
                    lineHeight: (13/100)*htmlFontSize,
                    width: (34/100)*htmlFontSize,
                    height: (13/100)*htmlFontSize,
                    formatter(params) {
                      return params.data+ (isH ? '%' : '℃')
                    }
                  },
                }
          }
          return seriesItemStyle
        }

        let option = {
          grid: {
            top: (45/100)*htmlFontSize,
            bottom: (10/100)*htmlFontSize,
            left: 0,
            right: 0,
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              position: 'bottom',
              // boundaryGap: true,
              data: xData,
              // 指示线
              axisPointer: {
                show: true,
                type: 'line',
                lineStyle: {
                  width: 1,
                  type: 'dashed',
                  color: '#368bac'
                },
              },
              // 刻度
              axisTick: {
                show: false  // 不显示刻度
              },
              // 坐标轴
              axisLine: {
                onZero: false,
                lineStyle: {
                  color: '#2f7d9f'  // 坐标轴颜色
                }
              },
              axisLabel: {
                interval: xInterval,
                showMaxLabel: true,
                color: '#51c1e1',
                fontSize: (10/100)*htmlFontSize,
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              name: '温度',
              nameTextStyle: {
                padding: [0, 0, -(5/100)*htmlFontSize, -(15/100)*htmlFontSize],
                color: '#92bd37'
              },
              min: TMinVal,
              max: TMaxVal,
              interval: 10,
              axisTick: { // 刻度
                show: false  // 不显示刻度
              },
              axisLine: { //坐标轴
                lineStyle: {
                  color: '#3b95b6'  // 坐标轴颜色
                }
              },
              axisLabel: { //刻度标签
                interval: 0,
                color: '#92bd37',
                fontSize: (10/100)*htmlFontSize,
                formatter: '{value}',
              },
              splitLine: { //分割线
                lineStyle: {
                  color: '#1b5477'
                }
              },
              markPoint: { // 标注
                symbol: 'circle'
              }
            },
            {
              type: 'value',
              name: '湿度',
              nameTextStyle: {
                padding: [0, -(15/100)*htmlFontSize, -(5/100)*htmlFontSize, 0],
                color: '#e99314'
              },
              min: 0,
              max: HMaxVal,
              interval: 10,
              axisTick: {
                show: false  // 不显示刻度
              },
              axisLine: {
                lineStyle: {
                  color: '#3b95b6'  // 坐标轴颜色
                }
              },
              axisLabel: {
                interval: 0,
                color: '#e99314',
                fontSize: (10/100)*htmlFontSize,
                formatter: '{value}',
              },
              splitLine: { //分割线
                lineStyle: {
                  color: '#1b5477'
                }
              }
            }
          ],
          series: [
            {
              name:'温度',
              type:'line',
              yAxisIndex: 0,
              data: TValArr,
              lineStyle: {
                width: (5/100)*htmlFontSize,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [{
                    offset: 0, color: '#92bd37' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#ffffff' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              },
              label: {
                backgroundColor: {
                  image: '/static/images/dkb/NARA/tv_bg.png'
                },
              },
              itemStyle: getSeriesItemStyle()
            },
            {
              name:'湿度',
              type:'line',
              yAxisIndex: 1,
              data: HValArr,
              lineStyle: {
                width: (5/100)*htmlFontSize,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [{
                    offset: 0, color: '#e99314' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#ffffff' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              },
              label: {
                backgroundColor: {
                  image: '/static/images/dkb/NARA/hv_bg.png'
                },
              },
              itemStyle: getSeriesItemStyle('isH')
            },
          ]
        }
        myChart.setOption(option, true)
      },
      // 屏幕变化图表自适应加载
      resizeGetChart () {
        echarts.init(document.getElementById('nowT')).resize()
        echarts.init(document.getElementById('nowH')).resize()
        echarts.init(document.getElementById('nowVrvT')).resize()
        echarts.init(document.getElementById('THMix')).resize()
      },
      // 视频操作（播放/暂停）
      videoOperate () {
        let video = document.getElementById('nowVideo')
        if (vm.videoStatus) {
          video.pause()
        } else {
          video.play()
        }
        vm.videoStatus = !(vm.videoStatus)
      },
      // 视频分页变化
      videoPageChange (currentPage) {
        vm.nowVideoIndex = currentPage-1
      },
      // 设置全屏
      settingFS () {
        // vm.$router.push('/Dkb/FScreen/NARA/VideoFS')
      }
    },
    watch: {
      // 屏幕变化，图表自适应加载
      '$store.state.isOnresize' (newVal, oldVal) {
        if (newVal !== oldVal) {
          vm.resizeGetChart()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.DkbFNARA::before {
  content: '';
  display: block;
  width: 7.76rem;
  height: 6.55rem;
  background: url('/static/images/dkb/NARA/halo_left.png') center no-repeat;
  background-size: 7.76rem 6.55rem;
  position: absolute;
  left: 1rem;
  bottom: 0;
}
.DkbFNARA::after {
  content: '';
  display: block;
  width: 4.96rem;
  height: 3.08rem;
  background: url('/static/images/dkb/NARA/halo_right.png') center no-repeat;
  background-size: 4.96rem 3.08rem;
  position: absolute;
  right: 0;
  top: 0;
}
.DkbFNARA {
  width: 100%;
  height: 100%;
  // overflow-y: scroll;
  padding-top: 0.26rem;
  padding-bottom: 0.53rem;
  background: url('/static/images/dkb/NARA/3d_shade.png') 5rem 0.42rem no-repeat;
  background-size: 6.73rem 4.12rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .topArea {
    flex-shrink: 0;
    width: 100%;
    padding: 0 1.06rem 0 0.24rem;
    display: flex;
    .sideArea::before {
      content: '';
      display: block;
      width: 1.17rem;
      height: 4.25rem;
      background: url(/static/images/dkb/NARA/side_icon.png) 0 center no-repeat;
      background-size: 100%;
      position: absolute;
      right: 0.9rem;
      top: 0.41rem;
    }
    .sideArea {
      flex-shrink: 0;
      width: 5.17rem;
      height: 5.04rem;
      background: url('/static/images/dkb/NARA/side_bg.png') right center no-repeat;
      background-size: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      .li {
        width: 2.85rem;
        height: 1.03rem;
        margin-left: 0.31rem;
        margin-bottom: 0.1rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .sum {
          font-size: 0.5rem;
          font-weight: bold;
        }
        .text {
          font-size: 0.15rem;
        }
        .item {
          display: flex;
          flex-direction: column;
          &:nth-child(1){
            flex-shrink: 0;
            width: 1.6rem;
            margin-left: 0.1rem;
          }
          &:nth-child(2){
            width: 100%;
            padding-right: 0.2rem;
          }
          .num,
          .PCT {
            font-size: 0.5rem;
            font-weight: lighter;
          }
        }

      }
      .li:first-child {
        margin-top: 0.31rem;
        flex-direction: column;
        justify-content: center;
      }
    }
    .d3{
      flex-shrink: 0;
      // width: 5.32rem;
      // height: 3.62rem;
      width: 5.95rem;
      height: 4.17rem;
      margin-top: 0.54rem;
      position: relative;
      .img {
        width: 100%;
        height: 100%;
      }
      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        background: url(/static/images/dkb/NARA/3d_halo.png) center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  .swiperArea {
    width: 11.66rem;
    // height: 2.73rem;
    height: calc(100% - 5.04rem);
    max-height: 2.73rem;
    margin: 0 auto;
    position: relative;
    // 轮播只显示2个
    .swiper.hasItem2 {
      .swiperItem {
        box-shadow: 0 0 0.34rem rgba(0, 0, 0, 0.2);
        background: url('/static/images/dkb/NARA/swiper_bg2.png') center no-repeat;
        background-size: 100% 100%;
      }
      // 记录列表
      .swiperItem.record {
        padding: 0 0.63rem 0.15rem 0.67rem;
        .li {
          .No {
            width: 0.4rem;
            margin-left: 0.2rem;
          }
          .name {
            width: 1.05rem;
          }
          .des {
            width: 0.95rem;
          }
          .time {
            width: 1.32rem;
            margin-left: 0.15rem;
          }
        }
      }
      // 温湿度
      .swiperItem.T {
        padding: 0 0.8rem;
       .GaugeArea {
          padding: 0.23rem 0 0;
       }
      }
    }
    // 轮播默认显示3个
    .swiper {
      width: 11.02rem;
      height: 100%;
      .swiperItem {
        background: url('/static/images/dkb/NARA/swiper_bg.png') center no-repeat;
        background-size: 100% 100%;
      }
      // 记录列表
      .swiperItem.record {
        width: 100%;
        padding: 0 0.17rem 0.15rem;
        text-align: center;
        display: flex;
        flex-direction: column;
        .recordTit {
          width: 100%;
          margin-bottom: 0.01rem;
          font-weight: bold;
          font-size: 0.15rem;
          line-height: 0.4rem;
        }
        .li.listTit {
          height: 0.34rem;
          line-height: 0.34rem;
        }
        .li {
          margin-right: 0.02rem;
          font-size: 0.12rem;
          line-height: 0.24rem;
          background-color: #072c4e;
          display: flex;
          .No {
            flex-shrink: 0;
            width: 0.38rem;
            margin-left: 0.08rem;
          }
          .name {
            flex-shrink: 0;
            width: 0.55rem;
          }
          .des {
            flex-shrink: 0;
            width: 0.86rem;
          }
          .time {
            flex-shrink: 0;
            width: 1.05rem;
          }
        }
        .recordList {
          width: 100%;
          max-height: 100%;
          overflow-x: hidden;
          overflow-y: scroll;
          .li:nth-child(odd) {
            background-color: #103b5c;
          }
        }
      }
      // 设备温湿度
      .swiperItem.deviceTH {
        padding: 0 0.35rem;
      }
      // 温度
      .swiperItem.T {
        width: 100%;
        padding: 0 0.2rem;
        display: flex;
        flex-direction: column;
        .selectArea {
          margin: 0.24rem 0 0;
          display: flex;
          justify-content: center;
          position: absolute;
          left: 0;
          right: 0;
          top: 1.15rem;
          margin: auto;
          z-index: 10;
          .text {
            padding-top: 0.08rem;
            color: #51c1e1;
            font-size: 0.12rem;
            position: relative;
          }
          .text+.text{
            margin-left: 0.12rem;
          }
          .text:before{
            content: '';
            display: block;
            width: 0.03rem;
            height: 0.03rem;
            border-radius: 50%;
            border: 0.01rem solid #51c1e1;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            margin: auto;
          }
          .text.active:before {
            background-color: #51c1e1;
            box-shadow: 0 0 0.03rem rgba(81, 793, 225, 0.58);
          }
        }
        .GaugeArea {
          flex-shrink: 0;
          width: 100%;
          padding: 0.23rem 0.2rem 0;
          display: flex;
          justify-content: space-between;
          .Gauge {
            width: 1.06rem;
            height: 0.76rem;
            .chart {
              width: 0.76rem;
              height: 0.76rem;
              margin: 0 auto;
              position: relative;
            }
            .chart:before{
              content: '';
              display: block;
              width: 0.07rem;
              height: 0.07rem;
              box-sizing: border-box;
              border-radius: 50%;
              border: 0.02rem solid #51c1e1;
              background-color: #093053;
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
              margin: auto;
              z-index: 9;
            }
            .text {
              width: 1rem;
              font-size: 0.15rem;
              line-height: 0.2rem;
              text-align: center;
              margin-top: -0.08rem;
            }
          }
        }
        .mixChart {
          width: 100%;
          height: 100%;
          // margin-top: 0.45rem;
        }
      }
      // 视频
      .swiperItem.video {
        position: relative;
        .videoBox {
          width: 3rem;
          height: 2rem;
          margin: 0.37rem auto 0;
          border: 0.03rem solid #7ca9d0;
          position: relative;
          #nowVideo {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .icon {
            width: 0.7rem;
            height: 0.7rem;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
          }
        }
        .fsBtn {
          display: block;
          width: 0.2rem;
          height: 0.2rem;
          background: url('/static/images/dkb/dbtn_s.png') center no-repeat;
          background-size: 100%;
          position: absolute;
          right: 0.1rem;
          top: 0.1rem;
          z-index: 9;
        }
        .DkbPaging {
          margin-top: 0.07rem;
        }
        .dPaging {
          width: 100%;
          margin-top: 0.06rem;
          font-size: 0.12rem;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          .li {
            font-size: 0.12rem;
            color: #75a2c9;
            margin-right: 0.07rem;
          }
          // .ico {
          // }
          .num {
            height: 0.18rem;
            line-height: 0.16rem;
            padding: 0 0.05rem;
          }
          .num.active {
            box-sizing: border-box;
            border: 0.01rem solid #75a2c9;
          }
        }
      }
    }
    .swiper-button {
      width: 0.16rem;
      height: 0.29rem;
      color: #7ca9d0;
      background: url('/static/images/dkb/NARA/swiper_icon.png') center no-repeat;
      background-size: 0.16rem 0.29rem;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      &.opacity {
        opacity: 0;
      }
      &.swiper-button-prev {
        transform: rotate(180deg);
        left: 0;
      }
      &.swiper-button-next {
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/NARA/NARA.vue